module.exports = __webpack_public_path__ + "img/qrcode-iOS.32d7cf07.svg";